module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/bipt/stringToBiptBlock.ts":
/*!***************************************!*\
  !*** ./src/bipt/stringToBiptBlock.ts ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToBiptBlock = void 0;
var stringToTextBlock_1 = __webpack_require__(/*! ./utils/stringToTextBlock */ "./src/bipt/utils/stringToTextBlock.ts");
var textBlockToBiptBlock_1 = __webpack_require__(/*! ./utils/textBlockToBiptBlock */ "./src/bipt/utils/textBlockToBiptBlock.ts");
function stringToBiptBlock(bipt) {
    return textBlockToBiptBlock_1.textBlockToBiptBlock(stringToTextBlock_1.stringToTextBlock(bipt));
}
exports.stringToBiptBlock = stringToBiptBlock;


/***/ }),

/***/ "./src/bipt/types/ChunkType.ts":
/*!*************************************!*\
  !*** ./src/bipt/types/ChunkType.ts ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunkType = void 0;
var ChunkType;
(function (ChunkType) {
    ChunkType["Block"] = "Block";
    ChunkType["Line"] = "Line";
})(ChunkType = exports.ChunkType || (exports.ChunkType = {}));


/***/ }),

/***/ "./src/bipt/utils/dedentTextBlock.ts":
/*!*******************************************!*\
  !*** ./src/bipt/utils/dedentTextBlock.ts ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.dedentTextBlock = void 0;
var getIndentSize_1 = __webpack_require__(/*! ./getIndentSize */ "./src/bipt/utils/getIndentSize.ts");
function dedentTextBlock(textBlock) {
    var lines = textBlock.lines, _a = textBlock.offset, column = _a.column, line = _a.line;
    var indentSize = getIndentSize_1.getIndentSize(lines);
    var indentMatcher = new RegExp("^[ \t]{" + indentSize + "}");
    return {
        lines: lines
            .map(function (line) {
            return line.replace(indentMatcher, "");
        }),
        offset: {
            line: line,
            column: column + indentSize
        }
    };
}
exports.dedentTextBlock = dedentTextBlock;


/***/ }),

/***/ "./src/bipt/utils/getIndentSize.ts":
/*!*****************************************!*\
  !*** ./src/bipt/utils/getIndentSize.ts ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getIndentSize = void 0;
var RE_INDENT = /^([ \t]*)\S/;
function getIndentSize(lines) {
    var result = Infinity;
    for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
        var line = lines_1[_i];
        var match = RE_INDENT.exec(line);
        if (match) {
            var indentSize = match[1].length;
            if (indentSize < result) {
                result = indentSize;
            }
        }
    }
    return result;
}
exports.getIndentSize = getIndentSize;


/***/ }),

/***/ "./src/bipt/utils/stringToTextBlock.ts":
/*!*********************************************!*\
  !*** ./src/bipt/utils/stringToTextBlock.ts ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToTextBlock = void 0;
function stringToTextBlock(value, line, column) {
    if (line === void 0) { line = 0; }
    if (column === void 0) { column = 0; }
    return {
        lines: value.split(/\r\n|\n/),
        offset: { column: column, line: line }
    };
}
exports.stringToTextBlock = stringToTextBlock;


/***/ }),

/***/ "./src/bipt/utils/textBlockToBiptBlock.ts":
/*!************************************************!*\
  !*** ./src/bipt/utils/textBlockToBiptBlock.ts ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.textBlockToBiptBlock = void 0;
var ChunkType_1 = __webpack_require__(/*! ../types/ChunkType */ "./src/bipt/types/ChunkType.ts");
var dedentTextBlock_1 = __webpack_require__(/*! ./dedentTextBlock */ "./src/bipt/utils/dedentTextBlock.ts");
var RE_BLANK = /^\s*$/;
var RE_UNINDENTED = /^(?:\S)/;
function textBlockToBiptBlock(textBlock) {
    var _a = dedentTextBlock_1.dedentTextBlock(textBlock), lines = _a.lines, offset = _a.offset;
    var lineOffset = offset.line, columnOffset = offset.column;
    var parsedChildren = [];
    var subLines = null;
    var subLineOffset = 0;
    var result = {
        type: ChunkType_1.ChunkType.Block,
        children: parsedChildren,
        content: lines.join("\n"),
        offset: offset
    };
    for (var i = 0; i < lines.length; i++) {
        var line = lines[i];
        if (RE_UNINDENTED.test(line)) {
            if (subLines) {
                parsedChildren.push(textBlockToBiptBlock({
                    lines: subLines,
                    offset: {
                        line: lineOffset + subLineOffset,
                        column: columnOffset
                    }
                }));
                subLines = null;
            }
            parsedChildren.push({
                type: ChunkType_1.ChunkType.Line,
                content: line,
                offset: {
                    line: lineOffset + i,
                    column: columnOffset
                }
            });
        }
        else if (RE_BLANK.test(line)) {
            if (subLines) {
                subLines.push(line);
            }
        }
        else {
            if (!subLines) {
                subLineOffset = i;
                subLines = [];
            }
            subLines.push(line);
        }
    }
    if (subLines) {
        parsedChildren.push(textBlockToBiptBlock({
            lines: subLines,
            offset: {
                line: lineOffset + subLineOffset,
                column: columnOffset
            }
        }));
    }
    return result;
}
exports.textBlockToBiptBlock = textBlockToBiptBlock;


/***/ }),

/***/ "./src/grammar/compileGrammar.ts":
/*!***************************************!*\
  !*** ./src/grammar/compileGrammar.ts ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.compileGrammar = void 0;
var compileRule_1 = __webpack_require__(/*! ./compileRule */ "./src/grammar/compileRule.ts");
function compileGrammar(grammar) {
    var result = {};
    for (var ruleName in grammar) {
        result[ruleName] = compileRule_1.compileRule(ruleName, grammar);
    }
    return result;
}
exports.compileGrammar = compileGrammar;


/***/ }),

/***/ "./src/grammar/compileRule.ts":
/*!************************************!*\
  !*** ./src/grammar/compileRule.ts ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileRule = void 0;
function compileRule(chunkType, grammar, isGroup) {
    if (isGroup === void 0) { isGroup = false; }
    var RE_GROUP = /\${((?:[^}]|\\})+)}/g;
    var rule = grammar[chunkType];
    var headExpr = rule.headExpr;
    var exprGroups = [];
    var compiledHeadExpr = headExpr.replace(RE_GROUP, function (match, groupName) {
        exprGroups.push(groupName);
        var compiledHeadExpr = compileRule(groupName, grammar, true).headExpr;
        return isGroup ?
            "(?:" + compiledHeadExpr + ")" :
            "(" + compiledHeadExpr + ")";
    });
    return __assign(__assign({}, rule), { headExpr: compiledHeadExpr, headRegex: new RegExp(compiledHeadExpr), subRules: exprGroups });
}
exports.compileRule = compileRule;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = exports.compileGrammar = void 0;
var compileGrammar_1 = __webpack_require__(/*! ./grammar/compileGrammar */ "./src/grammar/compileGrammar.ts");
Object.defineProperty(exports, "compileGrammar", { enumerable: true, get: function () { return compileGrammar_1.compileGrammar; } });
var parse_1 = __webpack_require__(/*! ./parse/parse */ "./src/parse/parse.ts");
Object.defineProperty(exports, "parse", { enumerable: true, get: function () { return parse_1.parse; } });


/***/ }),

/***/ "./src/parse/parse.ts":
/*!****************************!*\
  !*** ./src/parse/parse.ts ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
var stringToBiptBlock_1 = __webpack_require__(/*! ../bipt/stringToBiptBlock */ "./src/bipt/stringToBiptBlock.ts");
var biptChunksToRuleChunks_1 = __webpack_require__(/*! ./utils/biptChunksToRuleChunks */ "./src/parse/utils/biptChunksToRuleChunks.ts");
function parse(bipt, chunkTypes, compiledGrammar) {
    var biptBlock = stringToBiptBlock_1.stringToBiptBlock(bipt);
    return biptBlock
        && biptChunksToRuleChunks_1.biptChunksToRuleChunks(biptBlock.children, chunkTypes, compiledGrammar);
}
exports.parse = parse;


/***/ }),

/***/ "./src/parse/utils/biptChunkPairToRuleChunk.ts":
/*!*****************************************************!*\
  !*** ./src/parse/utils/biptChunkPairToRuleChunk.ts ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.biptChunkPairToRuleChunk = void 0;
var biptChunksToRuleChunks_1 = __webpack_require__(/*! ./biptChunksToRuleChunks */ "./src/parse/utils/biptChunksToRuleChunks.ts");
var parseLine_1 = __webpack_require__(/*! ./parseLine */ "./src/parse/utils/parseLine.ts");
function biptChunkPairToRuleChunk(head, body, chunkType, compiledGrammar) {
    var _a = compiledGrammar[chunkType].childRules, childRules = _a === void 0 ? [] : _a;
    var parsedLine = parseLine_1.parseLine(head.content, head.offset, chunkType, compiledGrammar);
    var result = {
        offset: head.offset,
        type: chunkType
    };
    if (body) {
        result = __assign(__assign({}, result), { children: biptChunksToRuleChunks_1.biptChunksToRuleChunks(body.children, childRules, compiledGrammar), content: body.content });
    }
    if (parsedLine) {
        result = __assign(__assign({}, result), parsedLine);
    }
    return result;
}
exports.biptChunkPairToRuleChunk = biptChunkPairToRuleChunk;


/***/ }),

/***/ "./src/parse/utils/biptChunksToRuleChunks.ts":
/*!***************************************************!*\
  !*** ./src/parse/utils/biptChunksToRuleChunks.ts ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.biptChunksToRuleChunks = void 0;
var ChunkType_1 = __webpack_require__(/*! ../../bipt/types/ChunkType */ "./src/bipt/types/ChunkType.ts");
var biptChunkPairToRuleChunk_1 = __webpack_require__(/*! ./biptChunkPairToRuleChunk */ "./src/parse/utils/biptChunkPairToRuleChunk.ts");
var RE_BLANK = /^\s*$/;
function biptChunksToRuleChunks(biptChunks, chunkTypes, compiledGrammar) {
    var result = [];
    for (var i = 0; i < biptChunks.length; i++) {
        var head = biptChunks[i];
        if (!RE_BLANK.test(head.content)) {
            if (head.type === ChunkType_1.ChunkType.Line) {
                var body = biptChunks[i + 1];
                if (body && body.type === ChunkType_1.ChunkType.Block) {
                    for (var _i = 0, chunkTypes_1 = chunkTypes; _i < chunkTypes_1.length; _i++) {
                        var ruleName = chunkTypes_1[_i];
                        var compiledRule = compiledGrammar[ruleName];
                        if (compiledRule.headRegex.test(head.content)) {
                            result.push(biptChunkPairToRuleChunk_1.biptChunkPairToRuleChunk(head, body, ruleName, compiledGrammar));
                            break;
                        }
                    }
                    i += 1;
                }
                else {
                    for (var _a = 0, chunkTypes_2 = chunkTypes; _a < chunkTypes_2.length; _a++) {
                        var ruleName = chunkTypes_2[_a];
                        var compiledRule = compiledGrammar[ruleName];
                        if (compiledRule.headRegex.test(head.content)) {
                            result.push(biptChunkPairToRuleChunk_1.biptChunkPairToRuleChunk(head, undefined, ruleName, compiledGrammar));
                            break;
                        }
                    }
                }
            }
            else {
                throw new Error("Unexpected BIPT chunk at " + head.offset);
            }
        }
    }
    return result;
}
exports.biptChunksToRuleChunks = biptChunksToRuleChunks;


/***/ }),

/***/ "./src/parse/utils/parseLine.ts":
/*!**************************************!*\
  !*** ./src/parse/utils/parseLine.ts ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLine = void 0;
function parseLine(content, offset, chunkType, compiledGrammar) {
    var _a = compiledGrammar[chunkType], headRegex = _a.headRegex, subRules = _a.subRules;
    var captures = headRegex.exec(content);
    if (captures !== null) {
        return {
            type: chunkType,
            captures: __spreadArrays([
                captures[0]
            ], captures
                .slice(1)
                .map(function (capture, i) {
                return capture !== undefined ?
                    parseLine(capture, offset, subRules[i], compiledGrammar) :
                    null;
            })),
            offset: offset
        };
    }
    else {
        return {
            type: chunkType,
            captures: [
                content
            ],
            offset: offset
        };
    }
}
exports.parseLine = parseLine;


/***/ })

/******/ });
//# sourceMappingURL=index.js.map